import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { FILES_ROLES } from '@/shared/guards/roles';
import { StoredFileDetailPage } from './pages/StoredFileDetailPage';
import { StoredFilesPage } from './pages/StoredFilesPage';

export const filesRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={FILES_ROLES} />,
    children: [
      {
        path: 'files',
        children: [
          { index: true, element: <StoredFilesPage /> },
          { path: ':fileId', element: <StoredFileDetailPage /> },
        ],
      },
    ],
  },
];
